{
  "{platform} version {version} · update {update}": "バージョン{version}（{platform}） · アップデート{update}",
  "{platform} version {version}": "バージョン{version}（{platform}）",
  "Delete my account, all personal data, and all video files streamed or uploaded online from EventLive servers": "アカウント、すべての個人データ、配信またはアップロードしたすべての動画ファイルをEventLiveのサーバーから削除",
  "Delete your Account? THIS ACTION IS IRREVERSIBLE": "アカウントを削除しますか？この操作は取り消せません",
  "You have {count} prepaid event. It's used automatically when you create an event.": {
    "other": "前払いイベントが{count}件あります。イベントを作成すると自動的に使用されます。"
  },
  "My Video Wall": "マイビデオウォール",
  "Download Everything": "すべてダウンロード",
  "Update Profile": "プロフィールを更新",
  "View Invoices and Manage Subscription": "請求書の確認とサブスクリプションの管理",
  "Reset Password": "パスワードをリセット",
  "Contact Support": "サポートに問い合わせる",
  "Review EventLive": "EventLiveを評価",
  "Delete Account": "アカウントを削除",
  "Sign Out": "ログアウト",
  "{team}'s Team": "{team}のチーム",
  "Team": "チーム",
  "Over {limit} in all": "合計で{limit}時間を超過",
  "Ticketed: no limit": "チケット制：上限なし",
  "{hours} in all": "合計{hours}時間",
  "MMMM YYYY": "YYYY年M月",
  "{month} (so far)": "{month}（現時点）",
  "Couldn't load this month. Please try again.": "この月のデータを読み込めませんでした。もう一度お試しください。",
  "How many hours of your videos people watched each month, live and replay. Each event includes {limit} viewer-hours; ticketed events have no limit.": "動画が毎月どれだけの時間視聴されたか（ライブ配信と録画の合計）を表示します。各イベントには延べ{limit}時間の視聴が含まれます。チケット制のイベントには上限がありません。",
  "Viewer-hours are shown to business accounts.": "延べ視聴時間はビジネスアカウントに表示されます。",
  "Couldn't load viewer-hours. Please try again later.": "延べ視聴時間を読み込めませんでした。しばらくしてからもう一度お試しください。",
  "No viewer-hours yet. They're updated every hour, within an hour of people watching.": "延べ視聴時間はまだありません。1時間ごとに更新され、視聴から1時間以内に反映されます。",
  "Counted every hour from the video our CDN delivered, on every player. Months are in UTC, and an event's hours count in the month people watched. Test events aren't included.": "当社のCDNが配信した動画をもとに、すべてのプレーヤーの視聴を1時間ごとに集計しています。月はUTC基準で、イベントの視聴時間は実際に視聴された月に計上されます。テストイベントは含まれません。",
  "{extra} over {limit} this month": "今月は{limit}時間を{extra}時間超過",
  "{extra} extra viewer-hours on {count} event over {limit}": {
    "other": "{limit}時間を超えた{count}件のイベントで、延べ視聴時間が{extra}時間超過"
  }
}
